export interface Adapter {
  screens?: Screen[];
  devices?: DEVICE[];
}

// screen
export enum SCREEN_TYPE {
  MAX = 'Max',
  MIN = 'Min'
}

export interface MaxScreen {
  type: SCREEN_TYPE.MAX;
  width: number;
}

export interface MinScreen {
  type: SCREEN_TYPE.MIN;
  width: number;
}

export type Screen = MaxScreen | MinScreen;

// device
export enum DEVICE {
  Mobile = 'Mobile',
  PC = 'PC',
  TV = 'TV'
}
